import React, { Component } from 'react'
import { FacebookProvider, ShareButton } from 'react-facebook'
import { Icon } from 'react-icons-kit'
import { facebookSquare } from 'react-icons-kit/fa/facebookSquare'
import './shareButton.css'

export default class ShareFacebook extends Component {
  render() {
    return (
      <FacebookProvider appId="596281580879543">
        <ShareButton disabled={this.props.disabled} href={this.props.url} className={`btn fb-share-button ${this.props.btnMd ? '' : 'btn-sm'} `}>
            <Icon size={19} icon={facebookSquare} />{' '}
          Compartir
        </ShareButton>
      </FacebookProvider>
    )
  }
}